import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NgIcon } from '@ng-icons/core';
import {
    QPX_POPOVER_HOVER_CONTEXT,
    QPX_POPOVER_REF,
    QpxButton,
    QpxIcon,
    QpxTypography,
    type DialogResult,
    type PopoverRef,
} from '@quipex/shared/ui';

@Component({
    selector: 'qpx-building-publish-gate-popover',
    imports: [MatButtonModule, NgIcon, QpxButton, QpxIcon, QpxTypography],
    templateUrl: './publish-gate-popover.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-popover building-publish-gate-overlay flex max-w-60 flex-col gap-3 p-4',
        '[attr.role]': 'popoverRef ? "dialog" : null',
        '(mouseenter)': 'onMouseEnter()',
        '(mouseleave)': 'onMouseLeave($event)',
    },
})
export class BuildingPublishGatePopover {
    //#region Dependency injection
    private readonly hoverContext = inject(QPX_POPOVER_HOVER_CONTEXT);
    protected readonly popoverRef =
        inject<PopoverRef<DialogResult>>(QPX_POPOVER_REF);
    //#endregion

    //#region Inputs
    public readonly canPublish = input.required<boolean>();
    public readonly message = input.required<string>();
    //#endregion

    //#region Template methods
    protected onMouseEnter(): void {
        this.hoverContext.onMouseEnter();
    }

    protected onMouseLeave(event: MouseEvent): void {
        this.hoverContext.onMouseLeave(event.relatedTarget);
    }

    protected onPublishBuildingRequested(): void {
        this.popoverRef.close({
            confirm: true,
            data: 'publish-building',
        });
    }
    //#endregion
}
